module.exports = __webpack_public_path__ + "static/img/8aa2ead5-7b06-4d4d-b913-60dec3a6e88e.4183170.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/8aa2ead5-7b06-4d4d-b913-60dec3a6e88e.jpg
// module id = ePiF
// module chunks = 1